import React, { useState, useMemo } from 'react';
import * as LucideIcons from 'lucide-react';

// Handle LucideIcons which may include lazy Getters (ESM Proxy behavior)
const allLucideIcons = Object.keys(LucideIcons)
  .filter((key) => /^[A-Z]/.test(key) && !key.endsWith('Icon')) // avoid duplicate .Icon suffixes
  .map((name) => {
    const Icon = LucideIcons[name];
    return { name, Icon };
  });

const IconPicker = ({ value, onChange }) => {
  const [searchTerm, setSearchTerm] = useState('');

  const filteredIcons = useMemo(() => {
    return allLucideIcons.filter(({ name }) =>
      name.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [searchTerm]);

  const selectedIcon = allLucideIcons.find(icon => icon.name === value);
  const displayIcons = useMemo(() => {
    const others = filteredIcons.filter(icon => icon.name !== value);
    return selectedIcon ? [selectedIcon, ...others] : others;
  }, [filteredIcons, value]);

  return (
    <div style={{width: '100%' }}>
      <input
        type="text"
        placeholder="Search icon..."
        value={searchTerm}
        onChange={e => setSearchTerm(e.target.value)}
        style={{
          width: '100%',
          padding: '10px',
          marginBottom: '12px',
          border: '1px solid #ccc',
          borderRadius: '6px',
          fontSize: '14px',
        }}
      />
      <div
        style={{
          maxHeight: '320px',
          overflowY: 'auto',
          border: '1px solid #ddd',
          borderRadius: '6px',
          padding: '10px',
        }}
      >
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(80px, 1fr))',
            gap: '12px',
          }}
        >
          {displayIcons.length === 0 && <div>No icons found.</div>}

          {displayIcons.map(({ name, Icon }) => (
            <button
              key={name}
              onClick={() => onChange(name)}
              style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                padding: '8px',
                borderRadius: '6px',
                border:
                  value === name ? '2px solid #2563eb' : '1px solid #ccc',
                backgroundColor: value === name ? '#eff6ff' : '#fff',
                cursor: 'pointer',
              }}
              title={name}
            >
              <Icon size={24} />
              <span
                style={{
                  fontSize: '11px',
                  marginTop: '4px',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  maxWidth: '72px',
                }}
              >
                {name}
              </span>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default IconPicker;